import { render, staticRenderFns } from "./ProgramReportModal.vue?vue&type=template&id=5980a0e6&scoped=true&"
import script from "./ProgramReportModal.vue?vue&type=script&lang=ts&"
export * from "./ProgramReportModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramReportModal.vue?vue&type=style&index=0&id=5980a0e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5980a0e6",
  null
  
)

export default component.exports